import { application } from './application';
import LemonwayIframeController from './lemonway_iframe_controller';


application.register('lemonway-iframe', LemonwayIframeController);
